export function replaceTextNodesForAccessibility(node, searchValues = {}) {
	const treeWalker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, (node) => {
		const matches = Object.keys(searchValues).find((searchValue) => node.textContent.includes(searchValue));

		if (matches) {
			return NodeFilter.FILTER_ACCEPT;
		} else {
			return NodeFilter.FILTER_SKIP;
		}
	});

	const childNodes = [];

	while (treeWalker.nextNode()) {
		childNodes.push(treeWalker.currentNode);
	}

	for (const childNode of childNodes) {
		if (childNode.parentNode.nodeName === 'SCRIPT') continue;

		const fragment = childNode.textContent.replace(/(\w+)/g, (match) => {
			const lang = searchValues[match];
			const replaceValue = `<span lang="${lang}">${match}</span>`;
			return lang ? replaceValue : match;
		});

		const documentFragment = document.createRange().createContextualFragment(fragment);
		Array.from(documentFragment.childNodes).forEach((newChildNode) => {
			childNode.parentElement.insertBefore(newChildNode, childNode);
		});
		childNode.parentNode.removeChild(childNode);
	}
}
